import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';

import axios from 'src/app/Service/axios';

import { NotificationService } from 'src/app/Service/notification.service';

import { ActivatedRoute, Router } from '@angular/router';

import { OtherService } from 'src/app/Service/other.service';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Location } from '@angular/common';

import * as XLSX from 'xlsx';

import Map from 'ol/Map';

import View from 'ol/View';

import OSM from 'ol/source/OSM';

import * as olProj from 'ol/proj';

import TileLayer from 'ol/layer/Tile';

import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';

import { DeviceDetectorService } from 'ngx-device-detector';

import momentJalaali from 'moment-jalaali';

import { registerables } from 'chart.js';

import Chart from 'chart.js/auto';

import { MapService } from 'src/app/Service/map.service';

import { DataService } from 'src/app/Service/data.service';

import zoomPlugin from 'chartjs-plugin-zoom';

import * as moment from 'moment-jalaali';

import { PersianNumberService } from 'ngx-persian';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { BingMaps, XYZ } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

declare let $: any;
@Component({
  selector: 'report',

  templateUrl: './report.component.html',

  styles: [
    `
      #excel-table-reportCar-base-route,
      #intermediate-Station-table,
      #excel-table-areaTravel,
      #SalarySummary_excel-list,
      #excel-SummaryByDay_Modal {
        overflow-x: auto;
        white-space: nowrap;
      }

      .bg-light {
        background-color: #ccffcc !important;
      }

      .bg-light-2 {
        background-color: #cceeff !important;
      }

      .modal #intermediate-Station-table {
        display: block;
      }

      @media screen and (max-height: 894px) {
        #excel-table-reportCar-base-route,
        .table-responsive {
          max-height: calc(100vh - 172px);
        }
      }

      @media screen and (max-width: 768px) {
        #excel-table-reportCar-base-route,
        .table-responsive {
          margin-bottom: 87px;
        }
      }
    `,
  ],
})
export class ReportComponent implements OnInit {
  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    public otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private deviceService: DeviceDetectorService,
    private mapService: MapService,
    private _location: Location,
    private dataService: DataService,
    private persianNumber: PersianNumberService,
    private gurdService: GurdServiceService,
  ) {
    this.isDesktop = this.deviceService.isDesktop();
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  isDesktop: any;

  fileName = 'ExcelSheet.xlsx';

  loggedinUserName: string | null = this.gurdService.decrypt(
    localStorage.getItem('FullName')!,
  );

  Id: any;

  ctx: any;

  obj: any;

  label: Array<any> = [];

  GeoFenceData: Array<any> = [];

  datachart: Array<any> = [];

  pointBackgroundColor: Array<any> = [];

  pointRadius: Array<any> = [];

  filteredData: Array<any> = [];

  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };

  acssess: any;

  polyganId: any;

  apiAdress: string = '';

  title: string = '';

  dataAz: any = '';

  dataTa: any = '';

  stime: any = '';

  etime: any = '';

  type: any = '0';

  reportData: any;

  total_fDischargeValue: any;

  total_fValue: any;

  reportData_Temp: any = [];

  Total: any = 0;

  TotalL: any = 0;

  Name: any = 0;

  remain: any = 0;

  fuel: any = 0;

  areaData: any;

  dictance: any = 0;

  stopTime: any = 0;

  hStopTime: any = 0;

  mStopTime: any = 0;

  sStopTime: any = 0;

  moveTime: any = 0;

  hmoveTime: any = 0;

  mmoveTime: any = 0;

  smoveTime: any = 0;

  TotalTime: any = 0;

  hTotalTime: any = 0;

  mTotalTime: any = 0;

  sTotalTime: any = 0;

  tServiceCharge: any = 0;

  siMoveTime: any;

  sOvertime: any = 0;

  mOvertime: any = 0;

  hOvertime: any = 0;

  overtime: any = 0;

  siMoveTimem: any;

  riderSalery: any;

  siPresentTime: any;

  siPresentTimem: any;

  siStopTime: any;

  siStopTimem: any;

  guidId: any;

  map: any;

  gpdioData: any;

  allGpdioData: any;

  pimayesh: number = 0;

  deviceEvent: any;

  fullDeviceEvent: any;

  refuelingReport: any;

  refuelingLitr: number = 0;

  refuelingCost: number = 0;

  saleryData: any;

  repairReport: any;

  tripInOutReport: any;

  currentDate: any;

  saleryTotal: number = 0;

  totalTimeSpent: any;

  speedCarData: any;

  summeryForRiderSalary: any = { source: -1, destination: -1 };

  buses = [];

  bTankerMood: boolean = false;

  list_Route: any = [];

  list_Car: any = [];

  list_RouteReport: any = [];

  list_RouteReport_Search: any = [];

  list_Intermediate_Station: any = [];

  list_ReportPassenger = [];

  list_ReportPassenger_Search = [];

  lst_Route_SummaryByDay = [];

  list_Checks: any = [];

  lst_SalarySummary: any = [];

  lst_SalarySummary_Search: any = [];

  totalPrice: number = 0;

  totalLength: number = 0;

  totalTime!: any;

  totalCount: number = 0;

  iAmount: number = 0;

  iCount: number = 0;

  iDays: number = 0;

  lstHeaders: any = [];

  lstRowValues: any = [];

  source: any;
  vector: any;
  layers: any = [];
  webAppName = (<any>window).webAppName;
  private bOfflineMap: boolean = (<any>window).bOfflineMap;
  private strMapUrl: string = (<any>window).strMapUrl;

  report_Obj = {
    iFunction: 0, // زمان کل

    iParkTime: 0, // کل زمان توقف

    iAbsoulatFunction: 0, // کل زمان حرکت

    Distance: 0, // کل میزان پیمایش

    fGasPer100: 0, // کل مصرف سوخت
  };

  dataStart: FormGroup = this.formBuilder.group({
    date: momentJalaali().format('jYYYY/jMM/01'),
  });

  mdl_Date: FormGroup = this.formBuilder.group({
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(
      window.localStorage.getItem('Session')!,
    ),

    strUnitID: new FormControl(''),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),
  });

  dataEnd: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  saleryEditForm: FormGroup = this.formBuilder.group({
    strStartTime: new FormControl(),
    iEncouragOvertime: new FormControl(),
    iIncentiveKm: new FormControl(),
    siServiceCharge: new FormControl(),
    strEndTime: new FormControl(),
    iAttendanceDriver: new FormControl(),
    strSession: new FormControl(),
    iSystemUser: new FormControl(),
    strUnitID: new FormControl(),
  });

  saleryEditAllForm: FormGroup = this.formBuilder.group({
    strStartTime: new FormControl('00:00'),
    strEndTime: new FormControl('00:00'),
    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),
    strUnitID: new FormControl(),
    strSDate: new FormControl(),
    strEDate: new FormControl(),
  });

  RouteReport_Model: FormGroup = this.formBuilder.group({
    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),

    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),

    iRoute: new FormControl(-1),

    strUnitID: new FormControl(''),

    strSDate: new FormControl(
      momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD'),
    ),

    strEDate: new FormControl(momentJalaali().format('jYYYY/jMM/jDD')),

    bSchedule: new FormControl(false),
  });

  ngOnInit(): void {
    this.currentDate = moment().locale('fa').format('jYYYY/jMM/jDD');

    var data = window.localStorage.getItem('menu') as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    $('.clockpicker').clockpicker({
      donetext: 'top',

      align: 'top',

      autoclose: true,
    });

    $('#edit-all-salery-modal').on('hidden.bs.modal', () => {
      this.saleryEditAllForm.reset({
        strSession: this.gurdService.decrypt(
          window.localStorage.getItem('Session')!,
        ),
        iSystemUser: this.gurdService.decrypt(
          window.localStorage.getItem('ID')!,
        ),
        strStartTime: '00:00',
        strEndTime: '00:00',
      });
    });

    this.route.params.subscribe((params) => {
      this.Id = params['id'];

      this.type = params['type'];

      this.polyganId = params['polygan'];

      this.dataAz = this.gurdService.decrypt(
        window.localStorage.getItem('reportDataZa')!,
      );

      this.dataTa = this.gurdService.decrypt(
        window.localStorage.getItem('reportDataTa')!,
      );

      this.stime = this.gurdService.decrypt(
        window.localStorage.getItem('reportStime')!,
      );

      this.etime = this.gurdService.decrypt(
        window.localStorage.getItem('reportEtime')!,
      );

      this.Name = this.gurdService.decrypt(
        window.localStorage.getItem('carName')!,
      );

      switch (this.Id) {
        case '1':
          this.apiAdress = 'ReportDailyDistance';
          this.title = `گزارش پیمایش دوره ای ${this.dataTa} - ${this.dataAz}`;
          this.fileName = 'گزارش پیمایش دوره ای.xlsx';
          break;
        case '2':
          this.apiAdress = 'ReportFuel';
          this.title = 'گزارش مصرف سوخت';
          this.fileName = 'گزارش مصرف سوخت.xlsx';

          break;
        case '3':
          this.apiAdress = 'ReportNetfunction';
          this.title = ` گزارش خالص کارکرد روزانه ${this.dataTa} - ${this.dataAz}`;
          this.fileName = 'گزارش خالص کارکرد روزانه.xlsx';

          break;
        case '4':
          this.apiAdress = 'Mobiles_GetSalari';
          this.title = ` حقوق رانندگان ${this.dataTa} - ${this.dataAz}`;
          this.fileName = 'حقوق رانندگان.xlsx';

          break;
        case '5':
          this.apiAdress = 'Report_MobilesRepair';
          this.title = ` گزارش تعمیرات ${this.dataTa} - ${this.dataAz}`;
          this.fileName = 'گزارش تعمیرات.xlsx';
          break;

        case 'repairServices':
          this.apiAdress = 'Report_MobilesRepairMaintenanceCondition';
          this.title = `سررسید سرویس ها`;
          this.fileName = 'سررسید سرویس ها.xlsx';
          break;
        case 'presenceCheck':
          this.apiAdress = '';
          this.title = `گزارش خودروهای واقع در محدوده`;
          this.fileName = 'گزارش خودروهای واقع در محدوده.xlsx';
          break;
        case 'historyCheck':
          this.apiAdress = '';
          this.title = `گزارش آخرین حضور در محدوده`;
          this.fileName = 'گزارش آخرین حضور در محدوده.xlsx';
          break;
        case 'busPresence':
          this.apiAdress = '';
          this.title = `گزارش حضور اتوبوس در ایستگاه ها`;
          this.fileName = 'گزارش حضور اتوبوس در ایستگاه ها.xlsx';
          break;
        case 'station':
          this.apiAdress = '';
          this.title = `گزارش حضور اتوبوس ها در ایستگاه`;
          this.fileName = 'گزارش حضور اتوبوس ها در ایستگاه.xlsx';
          break;
        case 'EmadadReport':
          this.apiAdress = '';
          this.title = `گزارش خدمت رسانی امداد خودرو "${this.gurdService.decrypt(localStorage.getItem('vehicleName')!)}" از ${this.dataTa} تا ${this.dataAz}`;
          this.fileName = 'گزارش خدمت رسانی امداد خودرو.xlsx';
          break;
        case '6':
          this.apiAdress = 'Radyab_MobilesRespectOriginDestination';
          this.title = `گزارش کارکرد مابین مبدا و مقصد ${this.dataAz}-${this.dataTa}`;
          this.fileName = 'گزارش کارکرد مابین مبدا و مقصد.xlsx';
          break;
        case '18':
          this.apiAdress = 'GeoFence_InspectionReport_Report4Mobile';
          this.title = `گزارش بازرسی تاسیسات ${this.dataAz}-${this.dataTa}`;
          this.fileName = 'گزارش بازرسی تاسیسات.xlsx';
          break;
        case '19':
          this.apiAdress = 'ServiceDelivery_MobilesReport';
          this.title = `گزارش خدمات رسانی خودرو ها ${this.dataAz}-${this.dataTa}`;
          this.fileName = 'گزارش خدمات رسانی خودرو ها.xlsx';
          break;
        default:
          this.apiAdress = 'ReportParkDetailByTime';
          this.title = `${this.Name} ${this.dataAz}`;
          break;
      }

      switch (this.type) {
        case '1':
          this.apiAdress = 'ReportParkDetailByTime';
          this.title = `گزارش  ${this.dataAz} - ${this.stime} تا ${this.etime}`;
          this.fileName = 'گزارش توقف ها.xlsx';
          this.guidId = 7;
          break;
        case '1-1':
          this.apiAdress = 'Tanker_Report_Feeding_Statistics4One';
          this.title = `گزارش از  ${this.dataAz} تا ${this.dataTa}`;
          this.fileName =
            'گزارش تعداد مرتبه آبگیری تانکر در طی بازه زمانی به تفکیک دوش.xlsx';
          // this.guidId = 7;
          break;
        case '1-2':
          this.apiAdress = 'Tanker_Report_Discharge';
          this.title = `گزارش  از  ${this.dataAz} تا ${this.dataTa}`;
          this.fileName =
            'گزارش میزان تخلیه تانکر به تفکیک های محل های توقف همراه با آدرس و موقعیت محل توقف.xlsx';
          // this.guidId = 7;
          break;
        case '1-3':
          this.apiAdress = 'Fueltank_Refueling';
          this.title = `گزارش  ${this.dataAz} تا ${this.dataTa}`;
          this.fileName = 'گزارش سوختگیری ها.xlsx';
          break;
        case '1-4':
          this.apiAdress = 'Fueltank_SuspiciousDischarge';
          this.title = `گزارش  ${this.dataAz} تا ${this.dataTa}`;
          this.fileName = 'گزارش تخلیه مشکوک.xlsx';
          break;
        case '2':
          this.apiAdress = 'ReportFunctionAndDistanceMountlyNew2';
          this.title = 'گزارش ساعات کارکرد';
          this.fileName = 'گزارش ساعات کارکرد.xlsx';

          this.guidId = 19;

          break;
        case '3':
          this.apiAdress = 'GetAllJournal';
          this.title = `${this.dataAz} - ${this.dataTa}`;
          this.guidId = 20;
          this.fileName = 'گزارش تخلفات رانندگان.xlsx';

          break;
        case '4':
          this.apiAdress = '';
          this.title = 'گزارش هزینه های تعمیرات خودرو';
          this.fileName = 'گزارش هزینه های تعمیرات خودرو.xlsx';

          this.guidId = 21;

          break;
        case '5':
          this.apiAdress = '';
          this.title = 'گزارش درآمد خودرو';
          this.fileName = 'گزارش درآمد خودرو.xlsx';

          this.guidId = 22;

          break;
        case '6':
          this.apiAdress = '';
          this.guidId = 22;

          this.title = `گزارش درآمد/هزینه ${this.dataAz}-${this.dataTa}`;
          this.fileName = 'گزارش درآمد/هزینه.xlsx';

          this.guidId = 23;

          break;
        case '7':
          this.apiAdress = 'Report_DeviceEvents';
          this.title = `وقایع ردیاب  ${this.dataAz}-${this.dataTa}`;
          this.fileName = 'وقایع ردیاب.xlsx';

          this.guidId = 38;

          break;
        case '8':
          this.apiAdress = 'Report_GPSIO';
          this.title = `ورودی ها ردیاب`;
          this.fileName = 'ورودی ها ردیاب.xlsx';

          this.guidId = 37;

          break;
        case '9':
          this.apiAdress = 'Report_InOutBasePreDifineGeoFance';
          this.title = `گزارش ورودی و خروج به محدوده `;
          this.fileName = 'گزارش ورودی و خروج به محدوده.xlsx';

          //this.guidId = 37;
          break;
        case '13':
          this.apiAdress = 'FuelReport_ReportMobile';
          this.title = `گزارش سوخت گیری `;
          this.fileName = 'گزارش سوخت گیری.xlsx';

          //this.guidId = 37;
          break;
        case '14':
          this.apiAdress = '';
          this.title = `گزارش حقوق رانندگان بر اساس ورود و خروج`;
          this.fileName = 'گزارش حقوق رانندگان بر اساس ورود و خروج.xlsx';

          //this.guidId = 37;
          break;
        case '15':
          this.apiAdress = 'Report_VelocityChangeGraph';
          this.title = `گزارش سرعت خودرو  `;
          //this.guidId = 37;
          break;
        case '15-1':
          this.apiAdress = 'Tanker_Report_DischargeBasedTime';
          this.title = ` نمودار روند تخلیه آب از تانکر  `;
          //this.guidId = 37;
          break;
        case '15-2':
          this.apiAdress = 'Tanker_Report_DischargeBasedSpeed';
          this.title = ` نمودار روند تخلیه آب از تانکر براساس سرعت `;
          //this.guidId = 37;
          break;
        case '15-3':
          this.apiAdress = 'Report_AccelerationGraph';
          this.title = `نمودار شتاب خودرو`;
          //this.guidId = 37;
          break;
        case '15-4':
          this.apiAdress = 'Fueltank_Consumption_Time';
          this.title = `نمودار مصرف براساس زمان`;
          break;
        case '15-5':
          this.apiAdress = 'Fueltank_InstantConsumption_Report';
          this.title = `نمودار مقدار سوخت مصرفی لحظه ای`;
          break;
        case '15-6':
          this.apiAdress = 'Flowmeter_Flowtrend';
          this.title = `روند جریان براساس داده های فلومتر`;
          break;
        case '16':
          this.apiAdress = '';
          this.title = `گزارش حقوق براساس فعالیت در محدوده   `;
          this.fileName = 'گزارش حقوق براساس فعالیت در محدوده .xlsx';

          //this.guidId = 37;
          break;
        case '17':
          this.apiAdress = '';
          this.title = `گزارش کارکرد مابین مبدا و مقصد`;
          this.fileName = 'گزارش کارکرد مابین مبدا و مقصد.xlsx';
          break;
        case '18':
          this.apiAdress = '';
          this.title = `گزارش حرکت مابین محدوده ها`;
          this.fileName = 'گزارش بازرسی تاسیسات.xlsx';
          this.otherService.setTitle(
            `${this.webAppName} | نرم افزار ردیاب -  گزارش حرکت مابین محدوده ها`,
          );
          break;
        case '18-0':
          this.apiAdress = '';
          this.title = `عملکرد مابین محدودها`;
          this.fileName = 'عملکرد مابین محدودها.xlsx';
          this.otherService.setTitle(
            `${this.webAppName} | نرم افزار ردیاب - عملکرد مابین محدودها`,
          );
          this.mdl_Date.patchValue({ strUnitID: this.Id });
          break;
        case '19':
          this.apiAdress = '';
          this.title = `گزارش خدمات رسانی ${this.dataAz} - ${this.dataTa}`;
          this.fileName = 'گزارش خدمات رسانی.xlsx';
          break;
        case '20':
        case '21':
          this.apiAdress = '';
          this.title = `گزارش جزییات تحلیل عملکرد ایاب و ذهاب `;
          this.fileName = 'گزارش جزییات تحلیل عملکرد ایاب و ذهاب.xlsx';
          break;
        case '21-1':
          this.apiAdress = '';
          this.title = `گزارش جزییات تحلیل عملکرد مسیر ها `;
          this.fileName = 'گزارش جزییات تحلیل عملکرد مسیر ها.xlsx';
          break;
        case '22':
          this.apiAdress = '';
          this.title = `گزارش سرجمع عملکرد خودرو براساس مسیر`;
          this.fileName = 'گزارش سرجمع عملکرد خودرو براساس مسیر .xlsx';
          break;
        case '23':
          this.apiAdress = '';
          this.title = `گزارش سرجمع عملکرد راننده براساس مسیر`;
          this.fileName = 'گزارش سرجمع عملکرد راننده براساس مسیر .xlsx';
          break;

          this.apiAdress = '';
          this.title = `عملکرد ایاب و ذهاب `;
          this.fileName = 'عملکرد ایاب و ذهاب.xlsx';

          break;
        default:
          break;
      }

      if (this.polyganId) {
        if (this.type == 10) {
          this.title = `تحلیل در محدوده`;
          this.fileName = 'تحلیل در محدوده.xlsx';

          this.getAreaData();
          this.guidId = 35;
        }

        if (this.type == 11) {
          this.title = `گزارش ورود و خروج `;
          this.fileName = 'گزارش ورود و خروج.xlsx';

          this.getEnterAndExit();
          //this.guidId = 35;
        }
      }
    });

    if (this.Id == 1 || this.Id == 2 || this.Id == 3) {
      this.otherService.Showspinner();

      this.getReport(this.apiAdress);
    }

    if (this.Id == 4) {
      this.getRiderSalery();
    }

    if (this.Id == 5) {
      this.getRepairReport();
    }

    if (this.Id == 'repairServices') {
      this.getPeriodicalServices();
    }

    if (this.Id == 'presenceCheck' || this.Id == 'historyCheck') {
      this.getArea();
    }

    if (this.Id == 'busPresence') {
      this.getBusList();
    }

    if (this.Id == 'EmadadReport') {
      this.getServicesProvided();
    }

    if (this.Id == 'station') {
      this.getLinesList();
      this.dataStart.controls['date'].setValue(
        momentJalaali().format('jYYYY/jMM/jDD'),
      );
      this.dataEnd.controls['date'].setValue(
        momentJalaali().format('jYYYY/jMM/jDD'),
      );
    }

    if (this.Id == 6) {
      this.getListOfSourceDest();
    }

    if (this.Id == 18) {
      this.getInspectioMain();
    }

    if (this.type == '1') {
      this.getStop(this.apiAdress);
    }

    if (this.type == '1-3' || this.type == '1-4') {
      this.getRefueling(this.apiAdress);
    }

    if (this.type == '1-1' || this.type == '1-2') {
      this.getTankerData(this.apiAdress);
    }

    if (this.type == '2') {
      this.getWork(this.apiAdress);
    }

    if (this.type == '3') {
      this.getJournal(this.apiAdress);
    }

    if (this.type == '4') {
      this.getAllRepairs(this.dataAz, this.dataTa);
    }

    if (this.type == '5') {
      this.getAllIncom(this.dataAz, this.dataTa);
    }

    if (this.type == '6') {
      this.getAllIncom(this.dataAz, this.dataTa);
      this.getAllRepairs(this.dataAz, this.dataTa);
    }

    if (this.type == '7') {
      this.getAllGpsData();
    }

    if (this.type == '8') {
      this.getGPSIO();
    }

    if (this.type == '9') {
      this.getEnterExitReport();
    }

    if (this.type == '13') {
      this.getRefuelingReport();
    }

    if (
      this.type == '15' ||
      this.type == '15-1' ||
      this.type == '15-2' ||
      this.type == '15-3' ||
      this.type == '15-4'
    ) {
      setTimeout(() => {
        this.newOpenMap();
      }, 500);

      this.getSpeedCar();
    }

    if (this.type == '15-5') {
      this.getSpeedCar();
    }

    if (this.type == '15-6') {
      setTimeout(() => {
        this.newOpenMap();
      }, 500);

      this.getSpeedCar();
    }

    if (this.type == '17') {
      this.getArea();
    }

    if (this.type == '18') {
      this.dataStart.controls['date'].setValue(
        momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD'),
      );
    }

    if (this.type == '19' || this.Id == '19') {
      this.getServicesProvided();
    }

    if (this.type == '20') {
      this.dataStart.controls['date'].setValue(
        momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD'),
      );

      this.dataEnd.controls['date'].setValue(
        momentJalaali().subtract(1, 'day').format('jYYYY/jMM/jDD'),
      );
    }

    if (
      this.type == '21' ||
      this.type == '21-1' ||
      this.type == '22' ||
      this.type == '23'
    ) {
      this.get_Route();

      this.getCarList();
    }

    // setTimeout(() => {

    //   this.summeryForRiderSalary.source = -1;

    //   this.summeryForRiderSalary.destination = -1;

    // }, 600);
  }

  ngOnDestroy() {
    this.otherService.setTitle('');
  }

  getBackUrl() {
    if (!isNaN(this.Id) && this.Id.length > 8) return ['/carInfo', this.Id];

    return ['/'];
  }

  get_Route = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_List`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'route-list' },
      });

      return;
    }

    let res = JSON.parse(resp.data);

    this.list_Route = res;
  };

  getCarList = async () => {
    // var model = {

    //   ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

    //   strUnitID: this.gurdService.decrypt(localStorage.getItem('UnitID')!),

    //   strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    //   bFromWeb: true

    // };

    // this.otherService.Showspinner();

    // const resp = await axios.post(`Radyab_GetAllCar?strSession=${this.gurdService.decrypt(localStorage.getItem('Session')!)}`, model);

    // this.otherService.nonespinner();

    // if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');

    // if (resp.data?.ISSessionExpired == true) {

    //   this.otherService.removeLocalStorage();

    //   return this.router.navigate(['/']);

    // }

    // this.list_Car = resp.data;

    //? دریافت لیست خودروها بدون تصویر

    if (!this.dataService.carList_New) {
      this.dataService.getCarList_New().then((resp: any) => {
        this.list_Car = this.dataService.carList_New;

        // console.log(this.list_Car)
      });
    } else {
      this.list_Car = this.dataService.carList_New;
    }
  };

  getServicesProvided = async () => {
    this.summeryForRiderSalary.vehicleName = this.gurdService.decrypt(
      localStorage.getItem('vehicleName')!,
    );

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: this.gurdService.decrypt(
        window.localStorage.getItem('unitId')!,
      ),

      strSDate: this.dataAz,

      strEDate: this.dataTa,
    };

    this.otherService.Showspinner();

    const resp = await axios.post(
      this.Id == '19'
        ? 'ServiceDelivery_MobilesReport'
        : 'ServiceDelivery_MobileReport',
      model,
    );

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: this.Id } });

      return;
    }

    this.reportData = JSON.parse(resp.data);
    this.summeryForRiderSalary.totalTime = 0;
    this.summeryForRiderSalary.totalTravel = 0;
    this.summeryForRiderSalary.totalServices = 0;
    this.reportData.forEach((element: any) => {
      this.summeryForRiderSalary.totalTime += element.iTime;
      this.summeryForRiderSalary.totalTravel += element.fKm;
      this.summeryForRiderSalary.totalServices += element.iCount;
    });

    if (this.type == '19' || this.Id == 'EmadadReport') {
      this.summeryForRiderSalary.totalTime = new Date(
        this.summeryForRiderSalary.totalTime * 1000,
      )
        .toISOString()
        .slice(11, 19);
      return;
    }
    this.summeryForRiderSalary.totalHTime = Math.floor(
      this.summeryForRiderSalary.totalTime / 3600,
    );
    this.summeryForRiderSalary.totalMTime = Math.floor(
      (this.summeryForRiderSalary.totalTime -
        this.summeryForRiderSalary.totalHTime * 3600) /
        60,
    );
    this.summeryForRiderSalary.totalSTime =
      this.summeryForRiderSalary.totalTime -
      this.summeryForRiderSalary.totalHTime * 3600 -
      this.summeryForRiderSalary.totalMTime * 60;
    this.summeryForRiderSalary.ftotalTime = `${this.summeryForRiderSalary.totalSTime}:${this.summeryForRiderSalary.totalMTime}:${this.summeryForRiderSalary.totalHTime} `;
  };

  searchBusesInStation = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iBusStop: this.summeryForRiderSalary.station,

      strSDate: this.dataStart.value.date,

      strEDate: this.dataEnd.value.date,
    };

    this.otherService.Showspinner();

    const resp = await axios.post('Bus_ReportBusesAtStattion', model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'bus-report' },
      });

      return;
    }

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);
  };

  getBusesInLines = async () => {
    if (!this.summeryForRiderSalary.bus || !this.dataStart.value.date) return;

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: this.summeryForRiderSalary.bus,

      strDate: this.dataStart.value.date,
    };

    this.otherService.Showspinner();

    const resp = await axios.post('Bus_ReportBusAtStattions', model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'bus-inLines' },
      });

      return;
    }

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);
  };

  getLinesList = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    this.otherService.Showspinner();

    const resp = await axios.post('Bus_ListBusLine', model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'lines-list' },
      });

      return;
    }

    this.buses = JSON.parse(resp.data);
  };

  getBusList = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    this.otherService.Showspinner();

    const resp = await axios.post('Bus_ListAllBuses', model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'bus-list' } });

      return;
    }

    this.buses = JSON.parse(resp.data);
  };

  getInspectioMain = async () => {
    var model = {
      strSDate: this.dataAz,

      strEDate: this.dataTa,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    this.otherService.Showspinner();

    const resp = await axios.post(this.apiAdress, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'inspect-main' },
      });

      return;
    }

    this.reportData = JSON.parse(resp.data);

    this.filteredData = this.reportData;
  };

  routeForInspection = async (data: any) => {
    window.localStorage.setItem(
      'RouteDate',
      this.gurdService.encrypt(data[0].strDate),
    );

    window.localStorage.setItem(
      'reportStime',
      this.gurdService.encrypt(data[0].strExitTime),
    );

    window.localStorage.setItem(
      'reportEtime',
      this.gurdService.encrypt(data[data.length - 1].strEnterTime),
    );

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: data[0].strUnitID,
    };

    this.otherService.Showspinner();

    const resp1 = await axios.post(`Radyab_InspectionGeoFence `, model);

    if (resp1.data && resp1.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'route-inspect' },
      });

      return;
    }

    this.otherService.nonespinner();

    localStorage.setItem(
      'inspectionZones',
      this.gurdService.encrypt(resp1.data),
    );

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`route/${this.Id}`]),
    );

    window.open(url, '_blank');
  };

  showOnMap = async (item: any) => {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`route/${item.strUnitID}`]),
    );

    window.open(url, '_blank');

    window.localStorage.setItem(
      'RouteDate',
      this.gurdService.encrypt(item.strDate),
    );

    window.localStorage.setItem(
      'reportStime',
      this.gurdService.encrypt(item.strSTime),
    );

    window.localStorage.setItem(
      'reportEtime',
      this.gurdService.encrypt(item.strETime),
    );
  };

  openRoute = async (item: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iGeoFence: this.summeryForRiderSalary.source,
    };

    var model2 = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iGeoFence: this.summeryForRiderSalary.destination,
    };

    this.otherService.Showspinner();

    const resp1 = await axios.post(`Radyab_GeoAFence`, model);

    if (resp1.data && resp1.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'geo-fence' } });

      return;
    }

    this.otherService.nonespinner();

    localStorage.setItem('zone1', this.gurdService.encrypt(resp1.data));

    const resp2 = await axios.post(`Radyab_GeoAFence`, model2);

    if (resp2.data && resp2.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'geo-fence-x' },
      });

      return;
    }

    localStorage.setItem('zone2', this.gurdService.encrypt(resp2.data));

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`route/${this.Id}`]),
    );

    window.open(url, '_blank');

    window.localStorage.setItem(
      'RouteDate',
      this.gurdService.encrypt(item.strDate),
    );

    window.localStorage.setItem(
      'reportStime',
      this.gurdService.encrypt(item.strExitSTime),
    );

    window.localStorage.setItem(
      'reportEtime',
      this.gurdService.encrypt(item.strEnterDTime),
    );
  };

  openRoute2 = async (item: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iGeoFence: this.summeryForRiderSalary.source,
    };

    var model2 = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iGeoFence: this.summeryForRiderSalary.destination,
    };

    this.otherService.Showspinner();

    const resp1 = await axios.post(`Radyab_GeoAFence`, model);

    if (resp1.data && resp1.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'geo-fence-z' },
      });

      return;
    }

    this.otherService.nonespinner();

    localStorage.setItem('zone1', this.gurdService.encrypt(resp1.data));

    const resp2 = await axios.post(`Radyab_GeoAFence`, model2);

    if (resp2.data && resp2.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'geo-fence-y' },
      });

      return;
    }

    localStorage.setItem('zone2', this.gurdService.encrypt(resp2.data));

    const url = this.router.serializeUrl(
      this.router.createUrlTree([`route/${item.strUnitID}`]),
    );

    window.open(url, '_blank');

    // console.log(item)

    window.localStorage.setItem(
      'RouteDate',
      this.gurdService.encrypt(item.strDate),
    );

    // window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strDestinationETime));
    window.localStorage.setItem(
      'reportStime',
      this.gurdService.encrypt(item.strSourceETime),
    );

    window.localStorage.setItem(
      'reportEtime',
      this.gurdService.encrypt(item.strDestinationSTime),
    );

    window.localStorage.setItem(
      'UnitID',
      this.gurdService.encrypt(item.strUnitID.toString()),
    );

    window.localStorage.setItem(
      'carName',
      this.gurdService.encrypt(item.strFullName.toString()),
    );

    window.localStorage.setItem(
      'plate',
      this.gurdService.encrypt(item.strVehicleNo.toString()),
    );
  };

  getListOfSourceDest = async () => {
    var model = {
      strSDate: this.dataAz,

      strEDate: this.dataTa,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    this.otherService.Showspinner();

    const resp = await axios.post(this.apiAdress, model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'source-dest' },
      });

      return;
    }

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);

    this.summeryForRiderSalary.totalTime = 0;

    this.summeryForRiderSalary.totalTravel = 0;

    this.summeryForRiderSalary.totaldTravel = 0;

    this.reportData.forEach((element: any) => {
      this.summeryForRiderSalary.totalTravel += element.iCount;

      this.summeryForRiderSalary.totalTime += element.iTime;

      this.summeryForRiderSalary.totaldTravel += element.fNavigation;
    });

    this.summeryForRiderSalary.totalTime = new Date(
      this.summeryForRiderSalary.totalTime * 1000,
    )
      .toISOString()
      .slice(11, 19);
  };

  searchInspections = async () => {
    $.confirm({
      title: `با توجه به زمان بر بودن این فرایند در صورت عدم دریافت نتیجه، مجددا دکمه بررسی را انتخاب کنید. این روند را تا زمانی که بازخورد انتخاب این دکمه، سریعا به اجرا درآید ادامه دهید.`,
      content: '',
      type: 'green',
      buttons: {
        ok: {
          text: 'بستن',
          btnClass: 'btn-primary',
          keys: ['enter'],
          action: async () => {
            var model = {
              iSystemUser: this.gurdService.decrypt(
                window.localStorage.getItem('ID')!,
              ),

              strSession: this.gurdService.decrypt(
                window.localStorage.getItem('Session')!,
              ),

              strUnitID: this.Id,

              strSDate: this.mdl_Date.controls['strSDate'].value,

              strEDate: this.mdl_Date.controls['strEDate'].value,
            };

            this.otherService.Showspinner();

            const resp = await axios.post(
              `Radyab_GeoFence_InspectionReport`,
              model,
            );

            if (resp.data && resp.data?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login'], {
                queryParams: { report: 'search-inspect' },
              });

              return;
            }

            this.otherService.nonespinner();

            this.reportData = JSON.parse(resp.data);

            this.reportData_Temp = this.reportData;

            this.summeryForRiderSalary.totalVisited = this.reportData.length;

            this.summeryForRiderSalary.totalTime = 0;

            this.summeryForRiderSalary.totalTravel = 0;

            this.summeryForRiderSalary.totalStop = 0;

            this.summeryForRiderSalary.totalStopTime = 0;

            let dataww = 0;

            this.reportData.forEach((element: any) => {
              // this.summeryForRiderSalary.totalTravel += element.fNavigation;

              this.summeryForRiderSalary.totalTravel += element.fNavigationKM;

              // this.summeryForRiderSalary.totalTime += element.iPresenceTime;

              // dataww += element.iPresenceTime;

              this.summeryForRiderSalary.totalTime += element.iTime;

              dataww += element.iTime;

              this.summeryForRiderSalary.totalStop += element.iStops;

              this.summeryForRiderSalary.totalStopTime += element.iStopsTime;
            });

            this.summeryForRiderSalary.totalTime = this.formattedTime(
              this.summeryForRiderSalary.totalTime,
            );

            this.summeryForRiderSalary.totalStopTime = this.formattedTime(
              this.summeryForRiderSalary.totalStopTime,
            );
          },
        },
      },
    });
  };

  formattedTime(input: number | string): string {
    const totalSeconds = Math.max(0, Math.floor(Number(input) || 0));

    const hours = Math.floor(totalSeconds / 3600);

    const minutes = Math.floor((totalSeconds % 3600) / 60);

    const seconds = totalSeconds % 60;

    const pad = (n: number) => String(n).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  filter_Inspections(value: string) {
    if (value != '') {
      this.reportData = this.reportData_Temp.filter((el: any) => {
        return (
          el.strGeoFenceName.startsWith(value) ||
          el.strNexFeoFenceName.startsWith(value)
        );
      });
    } else {
      this.reportData = this.reportData_Temp;
    }
  }

  search_Summarize = async () => {
    if (
      this.mdl_Date.get('strSDate')?.value == '' ||
      this.mdl_Date.get('strEDate')?.value == ''
    ) {
      return this.notifyService.showError(
        'تاریخ شروع و تاریخ پایان را وارد کنید',
      );
    }

    this.otherService.Showspinner();

    const resp = await axios.post(
      `Radyab_GeoFence_OriginDestination`,
      this.otherService.stringNumberToNumber(this.mdl_Date.value),
    );

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'search-summarize' },
      });

      return;
    }

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);

    this.reportData_Temp = this.reportData;

    // this.summeryForRiderSalary.totalVisited = this.reportData.length;

    this.summeryForRiderSalary.totalVisited = 0;

    this.summeryForRiderSalary.totalTime = 0;

    this.summeryForRiderSalary.totalTravel = 0;

    let dataww = 0;

    this.reportData.forEach((element: any) => {
      // this.summeryForRiderSalary.totalTravel += element.fNavigation;

      this.summeryForRiderSalary.totalTravel += element.fNavigation_km;

      // this.summeryForRiderSalary.totalTime += element.iPresenceTime;

      this.summeryForRiderSalary.totalTime += element.iSumTime;

      this.summeryForRiderSalary.totalVisited += element.iCount;

      dataww += element.iPresenceTime;
    });

    // this.summeryForRiderSalary.totalTime = new Date(this.summeryForRiderSalary.totalTime * 1000).toISOString().slice(11, 19);

    this.summeryForRiderSalary.totalTime = this.formattedTime(
      this.summeryForRiderSalary.totalTime,
    );
  };

  openRoute_Inspections(type: number, item: any) {
    if (type == 1) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`route/${this.Id}`]),
      );

      window.localStorage.setItem(
        'RouteDate',
        this.gurdService.encrypt(item.strDate),
      );

      window.localStorage.setItem(
        'reportStime',
        this.gurdService.encrypt(item.strEnterTime),
      );

      // window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strFullEnterTime));

      window.localStorage.setItem(
        'reportEtime',
        this.gurdService.encrypt(item.strExitTime),
      );

      // window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strFullExitTime));

      window.open(url, '_blank');
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`route/${this.Id}`]),
      );

      window.localStorage.setItem(
        'RouteDate',
        this.gurdService.encrypt(item.strDate),
      );

      window.localStorage.setItem(
        'reportStime',
        this.gurdService.encrypt(item.strExitTime),
      );

      // window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strFullExitTime));

      window.localStorage.setItem(
        'reportEtime',
        this.gurdService.encrypt(item.strEnterNextTime),
      );

      // window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strFullEnterNextTime));

      window.open(url, '_blank');
    }
  }

  selectAll_Summarize() {
    if (
      this.reportData.length > 0 &&
      this.list_Checks.length != this.reportData.length
    ) {
      this.list_Checks = [];

      this.reportData.forEach((a: any) => {
        this.list_Checks.push(a.iGeoFence_OriginDestination);
      });

      this.notifyService.showSuccess('همه موارد انتخاب شدند');
    } else {
      this.list_Checks = [];
    }
  }

  remove_Summarize() {
    if (this.list_Checks.length < 1)
      return this.notifyService.showError('لیست انتخابی شما خالی است');

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      lstiGeoFence_OriginDestination: this.list_Checks,
    };

    $.confirm({
      title: 'آیا از حذف اطمینان دارید؟',
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: 'حذف',
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: async () => {
            this.otherService.Showspinner();
            const resp = await axios.post(
              `Radyab_GeoFence_OriginDestination_Delete`,
              this.otherService.stringNumberToNumber(model),
            );
            this.otherService.nonespinner();
            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              this.router.navigate(['login']);
              return;
            } else {
              this.notifyService.showSuccess(' با موفقیت حذف شد');
              this.reportData = [];
            }
            return;
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  filter_Summarize(value: string) {
    if (
      value.includes('-') &&
      value.split('-').length > 1 &&
      value.split('-')[1].trim() != ''
    ) {
      let [strGeoFenceName, strNexFeoFenceName] = value.split('-');

      this.reportData = this.reportData_Temp.filter((el: any) => {
        return (
          el.strGeoFenceName.includes(strGeoFenceName.trim()) &&
          el.strNexFeoFenceName.includes(strNexFeoFenceName.trim())
        );
      });
    } else {
      this.reportData = this.reportData_Temp;
    }
  }

  isSelected(item: any): boolean {
    return this.list_Checks.indexOf(item) !== -1;
  }

  setCheckBox(value: boolean, item: any) {
    if (value === true) this.list_Checks.push(item.iGeoFence_OriginDestination);
    else {
      this.list_Checks.find((value: any) => {
        if (value === item.iGeoFence_OriginDestination) {
          const index = this.list_Checks.indexOf(
            item.iGeoFence_OriginDestination,
          );

          if (index !== -1) this.list_Checks.splice(index, 1);
        }
      });
    }
  }

  async setDropDown(e: any, field: any) {
    if (field == 0) this.summeryForRiderSalary.source = e.target.value;

    if (field == 1) this.summeryForRiderSalary.destination = e.target.value;

    if (field == 2) {
      this.summeryForRiderSalary.area = e.target.value;
      this.summeryForRiderSalary.text =
        e.target.options[e.target.options.selectedIndex].text;
      this.getAvailableCars(e.target.value);
    }

    if (field == 3) {
      this.summeryForRiderSalary.area = e.target.value;
      this.summeryForRiderSalary.text =
        e.target.options[e.target.options.selectedIndex].text;
      this.getLastPresence(e.target.value);
    }

    if (field == 4) {
      this.summeryForRiderSalary.line = e.target.value;
      var model = {
        strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
        iSystemUser: this.gurdService.decrypt(
          window.localStorage.getItem('ID')!,
        ),
        strCity: '0000',
        iBusLine: this.summeryForRiderSalary.line,
      };

      this.otherService.Showspinner();

      const resp = await axios.post(`Bus_ListBusStop4Line`, model);

      if (resp.data && resp.data?.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');

        this.otherService.removeLocalStorage();

        this.router.navigate(['login'], {
          queryParams: { report: 'set-down' },
        });

        return;
      }
      this.otherService.nonespinner();
      this.filteredData = JSON.parse(resp.data);
    }
  }

  getLastPresence = async (e: any) => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iGeoFence: e,
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Radyab_GetLastMobilesInGeoFence`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'last-presence' },
      });

      return;
    }

    let respJson = JSON.parse(resp.data);
    if (resp.data.length < 1) {
      this.reportData = [];
      return this.notifyService.showInfo(
        'خودرویی در محدوده مورد نظر وجود ندارد',
        'خطا!',
      );
    }
    this.filteredData = this.reportData;
    this.reportData = respJson;
  };

  searchTripStartEnd = async () => {
    if (this.type == 17) {
      if (
        this.summeryForRiderSalary.source == -1 ||
        this.summeryForRiderSalary.destination == -1
      )
        return this.notifyService.showInfo(
          'لطفا ابتدا مبدا و مقصد را مشخص کنید',
          'توجه',
        );

      $.confirm({
        title: `با توجه به زمان بر بودن این فرایند در صورت عدم دریافت نتیجه، مجددا دکمه بررسی را انتخاب کنید. این روند را تا زمانی که بازخورد انتخاب این دکمه، سریعا به اجرا درآید ادامه دهید.`,

        content: '',

        type: 'green',

        buttons: {
          ok: {
            text: 'بستن',

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {
              var model = {
                iSystemUser: this.gurdService.decrypt(
                  window.localStorage.getItem('ID')!,
                ),

                strSession: this.gurdService.decrypt(
                  window.localStorage.getItem('Session')!,
                ),

                strUnitID: this.Id,

                strSDate: this.dataStart.controls['date'].value,

                strEDate: this.dataEnd.controls['date'].value,

                iSourceGeoFence: this.summeryForRiderSalary.source,

                iDestinationGeoFence: this.summeryForRiderSalary.destination,
              };

              this.otherService.Showspinner();

              const resp = await axios.post(
                `Radyab_RespectOriginDestination`,
                model,
              );

              this.otherService.nonespinner();

              if (resp.data && resp.data?.ISSessionExpired == true) {
                this.notifyService.showError('لطفا وارد سیستم شوید');

                this.otherService.removeLocalStorage();

                this.router.navigate(['login'], {
                  queryParams: { report: 'xxy7k' },
                });

                return;
              }

              this.tripInOutReport = JSON.parse(resp.data);

              this.summeryForRiderSalary.totalPresense = 0;

              this.summeryForRiderSalary.totalTime = 0;

              this.summeryForRiderSalary.totalTravel = 0;

              this.tripInOutReport.forEach((element: any) => {
                this.summeryForRiderSalary.totalPresense +=
                  element.iTotalPresenceTime;

                this.summeryForRiderSalary.totalTime += element.iTime;

                this.summeryForRiderSalary.totalTravel += element.fNavigation;
              });

              this.summeryForRiderSalary.totalPresense = new Date(
                this.summeryForRiderSalary.totalPresense * 1000,
              )
                .toISOString()
                .slice(11, 19);

              this.summeryForRiderSalary.totalTime = new Date(
                this.summeryForRiderSalary.totalTime * 1000,
              )
                .toISOString()
                .slice(11, 19);
            },
          },
        },
      });
    } else {
      $.confirm({
        title: `با توجه به زمان بر بودن این فرایند در صورت عدم دریافت نتیجه، مجددا دکمه بررسی را انتخاب کنید. این روند را تا زمانی که بازخورد انتخاب این دکمه، سریعا به اجرا درآید ادامه دهید.`,
        content: '',
        type: 'green',
        buttons: {
          ok: {
            text: 'بستن',
            btnClass: 'btn-primary',
            keys: ['enter'],
            action: async () => {
              var model = {
                iSystemUser: this.gurdService.decrypt(
                  window.localStorage.getItem('ID')!,
                ),
                strSession: this.gurdService.decrypt(
                  window.localStorage.getItem('Session')!,
                ),
                strUnitID: this.Id,
                strSDate: this.dataStart.controls['date'].value,
                strEDate: this.dataEnd.controls['date'].value,
              };
              this.otherService.Showspinner();

              const resp = await axios.post(
                `Radyab_Transportation_DailyReport`,
                model,
              );

              this.otherService.nonespinner();

              this.tripInOutReport = JSON.parse(resp.data);

              this.summeryForRiderSalary.totalPresense = 0;

              this.summeryForRiderSalary.totalTime = 0;

              this.summeryForRiderSalary.totalTravel = 0;

              this.summeryForRiderSalary.iSalary = 0;

              this.tripInOutReport.forEach((element: any) => {
                this.summeryForRiderSalary.totalPresense +=
                  element.iTotalPresenceTime;

                this.summeryForRiderSalary.totalTime += element.iTime;

                this.summeryForRiderSalary.totalTravel += element.fNavigation;

                this.summeryForRiderSalary.iSalary += element.iSalary;
              });

              this.summeryForRiderSalary.totalPresense = new Date(
                this.summeryForRiderSalary.totalPresense * 1000,
              )
                .toISOString()
                .slice(11, 19);

              this.summeryForRiderSalary.totalTime = new Date(
                this.summeryForRiderSalary.totalTime * 1000,
              )
                .toISOString()
                .slice(11, 19);
            },
          },
        },
      });
    }
  };

  checkDeparturePoint = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strUnitID: this.Id,
      tiGeoFenceUsgae: 4,
    };

    const resp = await axios.post(`Radyab_GetMobileSorDGeoFence`, model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'check-point' },
      });

      return;
    }
    this.summeryForRiderSalary.source = Number(resp.data);
    //////////////////////////////
  };

  checkDestinationPoint = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strUnitID: this.Id,
      tiGeoFenceUsgae: 5,
    };

    const resp = await axios.post(`Radyab_GetMobileSorDGeoFence`, model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'check-point-x' },
      });

      return;
    }
    this.summeryForRiderSalary.destination = Number(resp.data);
  };

  getAvailableCars = async (e: any) => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      iGeoFence: e,
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`Radyab_GetMobileInGeoFence`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'available-cars' },
      });

      return;
    }
    if (resp.data.length < 1) {
      this.reportData = [];
      return this.notifyService.showInfo(
        'خودرویی در محدوده مورد نظر وجود ندارد',
        'خطا!',
      );
    }
    this.reportData = resp.data;

    this.filteredData = this.reportData;
  };

  getArea = async () => {
    var model = {
      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Radyab_GeoFence`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'area' } });

      return;
    }

    let respJson = JSON.parse(resp.data);

    this.GeoFenceData = respJson;

    if (this.type == '17') {
      this.checkDeparturePoint();

      this.checkDestinationPoint();
    }

    if (localStorage.getItem('ddval')) {
      this.summeryForRiderSalary.area = this.gurdService.decrypt(
        localStorage.getItem('ddval')!,
      );
      this.getLastPresence(this.summeryForRiderSalary.area);
      localStorage.removeItem('ddval');
    }

    if (this.Id == 'presenceCheck' && localStorage.getItem('ddval')) {
      this.summeryForRiderSalary.area = this.gurdService.decrypt(
        localStorage.getItem('ddval')!,
      );
      this.getAvailableCars(this.summeryForRiderSalary.area);
      localStorage.removeItem('ddval');
      localStorage.removeItem('nameOfDriv');
    }
  };

  filterRadyabStatus(val: any) {
    if (val.value == '-1') {
      this.deviceEvent = this.fullDeviceEvent;
    } else {
      this.deviceEvent = this.fullDeviceEvent.filter((el: any) => {
        return el.strDeviceStatus_strComment == val.value;
      });
    }
  }

  getSeparatedValue(input: any) {
    return new Number(input).toLocaleString('fa-ir');
  }

  toPersian(input: any) {
    return this.persianNumber.toPersian(input);
  }

  getAllGpsData = async () => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      tiDeviceEventsType: this.gurdService.decrypt(
        window.localStorage.getItem('deviceEvents')!,
      ),
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    this.otherService.Showspinner();
    const resp = await axios.post(this.apiAdress, model);
    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'gps-vxZAm' } });

      return;
    }
    this.otherService.nonespinner();

    this.deviceEvent = JSON.parse(resp.data);
    this.fullDeviceEvent = JSON.parse(resp.data);
  };

  sortBy(input: any) {
    if (this.reportData.length > 0) {
      this.reportData.sort((a: any, b: any) => {
        if (input == 0) {
          var textA = a.strFullName.toUpperCase();
          var textB = b.strFullName.toUpperCase();
        }
        if (input == 1) {
          var textA = a.strMobileType_strComment.toUpperCase();
          var textB = b.strMobileType_strComment.toUpperCase();
        }
        if (input == 2) {
          var textA = a.strMobileDomain_strComment.toUpperCase();
          var textB = b.strMobileDomain_strComment.toUpperCase();
        }

        if (input == 3) {
          return a.tiStatus - b.tiStatus;
        }

        if (input == 4) {
          var textA = a.strTitle.toUpperCase();
          var textB = b.strTitle.toUpperCase();
        }

        if (input == 5) {
          return a.iCount - b.iCount;
        }

        if (input == 6) {
          return a.iPresenceTime - b.iPresenceTime;
        }

        if (textA > textB) return textA < textB ? 1 : textA > textB ? -1 : 0;
        if (textA < textB) return textA < textB ? -1 : textA > textB ? 1 : 0;
        return;
      });
    }
  }

  sortByDate() {
    this.deviceEvent.sort((a: any, b: any) => {
      return (new Date(b.strDate) as any) - (new Date(a.strDate) as any);
    });
  }

  getSpeedCar = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: this.Id,

      strDate: this.dataAz,

      strSDate: this.dataAz,

      strEDate: this.dataTa,

      strSTime: this.stime,

      strETime: this.etime,
    };

    this.otherService.Showspinner();

    const resp = await axios.post(this.apiAdress, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'speed-car' } });

      return;
    }

    this.speedCarData = JSON.parse(resp.data);

    if (!this.speedCarData.length)
      return this.notifyService.showError('اطلاعاتی یافت نشد');

    this.obj = this.speedCarData;

    this.label = [];

    this.datachart = [];

    this.pointBackgroundColor = [];

    this.obj.forEach((element: any) => {
      this.label.push(
        element.X ||
          element.strTime ||
          element.strDateTime ||
          element.iSpeed ||
          element.strSTime ||
          element.strDateTime,
      );

      this.datachart.push(
        element.Y ||
          element.fVolume ||
          element.Acceleratio ||
          element.fValue ||
          element.fLiter,
      );

      if (this.type == '15-3') {
        this.pointBackgroundColor.push(
          element.bCritical ? '#cf1527' : '#00b300',
        );

        this.pointRadius.push(element.bCritical ? 4 : 3);
      }
    });

    const ctx = document.getElementById('myChart') as any;

    if (this.ctx) this.ctx.destroy();

    this.ctx = new Chart(ctx, {
      type: 'line',

      data: {
        labels: this.label,

        datasets: [
          {
            label:
              this.type == 15
                ? '(km) سرعت '
                : this.type == '15-3'
                  ? 'شتاب'
                  : ' لیتر ',

            data: this.datachart,

            fill: false,

            borderColor: '#b3b3b3',

            backgroundColor: '#e755ba',

            pointBackgroundColor:
              this.type == '15-3' ? this.pointBackgroundColor : '#00b300',

            pointBorderColor:
              this.type == '15-3' ? this.pointBackgroundColor : '#00b300',

            pointRadius: this.type == '15-3' ? this.pointRadius : 2,

            stepped: this.type == '15-3' ? true : false,
          },
        ],
      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false,
        },

        onClick: (e) => {
          const points = this.ctx.getElementsAtEventForMode(
            e,
            'nearest',
            { intersect: true },
            true,
          );

          const firstPoint = points[0];

          const label = this.ctx.data.labels[firstPoint?.index];

          var loc = this.speedCarData.filter((el: any) => {
            return (
              (el.X ||
                el.strTime ||
                el.strDateTime ||
                el.iSpeed ||
                el.strSTime) == label
            );
          });

          this.mapService.removeLayerByName('marker', this.map);

          if (this.type == '15-3') {
            let New_loc = [{ fLon: loc[0].dLongitude, fLat: loc[0].dLatitude }];

            var marker = this.mapService.createMarker(
              [New_loc[0].fLon, New_loc[0].fLat],
              '../../assets/Img/marker5.png',
              `markerId`,
              `marker`,
              {},
            );

            this.map.addLayer(marker);

            this.mapService.fitMap(New_loc, this.map);
          }

          if (this.type != '15-3') {
            var marker = this.mapService.createMarker(
              [loc[0]?.fLon, loc[0]?.fLat],
              '../../assets/Img/marker5.png',
              `markerId`,
              `marker`,
              {},
            );

            this.map.addLayer(marker);

            this.mapService.fitMap(loc, this.map);
          }
        },

        plugins: {
          zoom: {
            pan: {
              enabled: true,

              mode: 'x',

              threshold: 10,
            },

            zoom: {
              wheel: {
                enabled: true,
              },

              pinch: {
                enabled: true,
              },

              mode: 'x',
            },
          },
        },

        scales: {
          x: {
            ticks: {
              color: 'black',

              font: {
                family: 'bYekan',

                size: 12,
              },
            },
          },
        },
      },
    });

    this.ctx.canvas.addEventListener('mousedown', (event: any) => {
      if (event.currentTarget) event.currentTarget.style.cursor = 'grab';
    });

    this.ctx.canvas.addEventListener('mouseup', (event: any) => {
      if (event.currentTarget) event.currentTarget.style.cursor = 'default';
    });
  };

  resetZoom() {
    this.ctx.resetZoom();
  }

  getGPSIO = async () => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    if (!this.dataService.gpsIoData) {
      this.dataService.getGpsIo(model).then((resp: any) => {
        this.gpdioData = this.dataService.gpsIoData;
        this.allGpdioData = this.dataService.gpsIoData;
      });
    } else {
      this.gpdioData = this.dataService.gpsIoData;
      this.allGpdioData = this.dataService.gpsIoData;
    }
  };

  getPeriodicalServices = async () => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    this.otherService.Showspinner();
    const resp = await axios.post(this.apiAdress, model);
    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'period-xc' } });

      return;
    }
    this.otherService.nonespinner();
    this.repairReport = JSON.parse(resp.data);
  };

  getRepairReport = async () => {
    var model = {
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    this.otherService.Showspinner();
    const resp = await axios.post(this.apiAdress, model);
    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'repair-report' },
      });

      return;
    }
    this.otherService.nonespinner();
    this.repairReport = JSON.parse(resp.data);
    this.summeryForRiderSalary.totalCost = 0;
    this.repairReport.forEach((element: any) => {
      this.summeryForRiderSalary.totalCost += element.iTotalCost;
    });
  };

  getRiderSalery = async () => {
    var model = {
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    this.otherService.Showspinner();
    const resp = await axios.post(this.apiAdress, model);
    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'salery-wdxSX' },
      });

      return;
    }
    this.otherService.nonespinner();
    this.riderSalery = JSON.parse(resp.data);

    this.summeryForRiderSalary.totalTime = 0;
    this.summeryForRiderSalary.totalRide = 0;
    this.summeryForRiderSalary.totalSalary = 0;
    Array.from(this.riderSalery).forEach((element: any) => {
      this.summeryForRiderSalary.totalTime += element.iTotalTime;
      this.summeryForRiderSalary.totalRide += element.fTotalKm;
      this.summeryForRiderSalary.totalSalary += element.iSalary;
    });

    this.summeryForRiderSalary.totalTime =
      Math.floor(this.summeryForRiderSalary.totalTime / 60) +
      ':' +
      (this.summeryForRiderSalary.totalTime % 60 < 10
        ? '0' + (this.summeryForRiderSalary.totalTime % 60)
        : this.summeryForRiderSalary.totalTime % 60);
  };

  openUploder() {
    $('#exelUpload').click();
  }

  getEnterExitReport = async () => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    if (!this.dataService.enterExitdata) {
      this.dataService.getEnterAndExit(model).then((resp: any) => {
        this.gpdioData = this.dataService.enterExitdata;
        this.allGpdioData = this.dataService.enterExitdata;
      });
    } else {
      this.gpdioData = this.dataService.enterExitdata;
      this.allGpdioData = this.dataService.enterExitdata;
    }
  };

  getRefuelingReport = async () => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    const resp = await axios.post(this.apiAdress, model);
    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'fuel-jx09aZ' },
      });

      return;
    }
    this.refuelingReport = JSON.parse(resp.data);
    this.refuelingReport.forEach((el: any) => {
      this.refuelingLitr = this.refuelingLitr + el.fLiter;
      this.refuelingCost = this.refuelingCost + el.iCost;
    });
  };

  goBack() {
    this._location.back();
    this.dataService.stopData = null;
    this.dataService.enterExitdata = null;
    this.dataService.gpsIoData = null;
  }

  getReport = async (api: string) => {
    this.otherService.Showspinner();

    try {
      const session = encodeURIComponent(
        this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      );

      const resp = await axios.post(
        `${api}?vstrSDate=${this.dataAz}&vstrUnitID=&vstrEDate=${this.dataTa}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
      );

      this.otherService.nonespinner();

      this.reportData = resp.data;

      if (resp.data && resp.data?.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');

        this.otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { report: this.Id } });

        return;
      }

      if (this.Id == '1') {
        this.reportData.forEach((element: any, index: number) => {
          this.Total = Math.floor(element.fDistance + this.Total);
        });
      }

      if (this.Id == '2') {
        this.reportData.forEach((element: any, index: number) => {
          this.TotalL = Math.floor(element.fGasPer100 + this.TotalL);

          this.reportData[index].fGasPer100 = Math.floor(
            this.reportData[index].fGasPer100,
          );
        });
      }
    } catch {
      this.notifyService.showError('خطای داخلی رخ داده است !');
    } finally {
      this.otherService.nonespinner();
    }
  };

  getStop = async (api: string) => {
    this.dataService.getStop(this.Id).then((resp: any) => {
      this.reportData = this.dataService.stopData;
    });
  };

  getTankerData = async (api: string) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: this.Id,

      strSDate: this.dataAz,

      strEDate: this.dataTa,
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`${api}`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'tanker-cVnjFX' },
      });

      return;
    }

    this.reportData = JSON.parse(resp.data);

    this.total_fDischargeValue = 0;

    for (const item of this.reportData) {
      this.total_fDischargeValue += parseFloat(item.fDischargeValue || 0);
    }
  };

  getRefueling = async (api: string) => {
    this.total_fValue = 0;

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      strUnitID: this.Id,

      strSDate: this.dataAz,

      strEDate: this.dataTa,
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`${api}`, model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'tanker-cVnjFX' },
      });

      return;
    }

    this.otherService.nonespinner();

    this.reportData = JSON.parse(resp.data);

    this.reportData.forEach((el: any) => {
      this.total_fValue += el.fValue;
    });

    // this.bTankerMood = true;
  };

  getJournal = async (api: string) => {
    var model = {
      strSDate: this.dataAz,
      strUnitID: this.Id,
      strEDate: this.dataTa,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    };
    const resp = await axios.post(`${api}`, model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'JOURNAL' } });

      return;
    }

    this.reportData = resp.data;
  };

  getWork = async (api: string) => {
    this.otherService.Showspinner();

    const session = encodeURIComponent(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    );
    const resp = await axios.post(
      `${api}?vstrSDate=${this.dataAz}&vstrUnitID=${this.Id}&vstrEDate=${
        this.dataTa
      }&iSTime=${this.stime}&iETime=${
        this.etime
      }&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
    );

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'WORK' } });

      return;
    }

    this.reportData = resp.data;

    this.otherService.nonespinner();

    this.report_Obj = {
      iFunction: 0, // زمان کل

      iParkTime: 0, // کل زمان توقف

      iAbsoulatFunction: 0, // کل زمان حرکت

      Distance: 0, // کل میزان پیمایش

      fGasPer100: 0, // کل مصرف سوخت
    };

    this.reportData.forEach((element: any, index: number) => {
      this.report_Obj = {
        iFunction: this.report_Obj.iFunction + element.iFunction,

        iParkTime: this.report_Obj.iParkTime + element.iParkTime,

        iAbsoulatFunction:
          this.report_Obj.iAbsoulatFunction + element.iAbsoulatFunction,

        Distance: this.report_Obj.Distance + element.Distance,

        fGasPer100: this.report_Obj.fGasPer100 + element.fGasPer100,
      };

      // this.fuel = element.fGasPer100 + this.fuel;

      // this.dictance = element.Distance + this.dictance;

      // this.stopTime = element.iParkTime + this.stopTime;

      // this.moveTime = element.iAbsoulatFunction + this.moveTime;

      // this.TotalTime = element.iFunction + this.TotalTime;
    });

    // this.hStopTime = Math.floor(this.stopTime / 3600);

    // this.mStopTime = Math.floor((this.stopTime - this.hStopTime * 3600) / 60);

    // this.sStopTime = this.stopTime - (this.hStopTime * 3600 + this.mStopTime * 60);

    // this.hmoveTime = Math.floor(this.moveTime / 3600);

    // this.mmoveTime = Math.floor((this.moveTime - this.hmoveTime * 3600) / 60);

    // this.smoveTime = this.moveTime - (this.hmoveTime * 3600 + this.mmoveTime * 60);

    // this.hTotalTime = Math.floor(this.TotalTime / 3600);

    // this.mTotalTime = Math.floor((this.TotalTime - this.hTotalTime * 3600) / 60);

    // this.sTotalTime = this.TotalTime - (this.hTotalTime * 3600 + this.mTotalTime * 60);
  };

  format_Time(totalTime: number): string {
    const hours = Math.floor(totalTime / 3600);
    const minutes = Math.floor((totalTime % 3600) / 60);
    const seconds = totalTime % 60;
    return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  getAllRepairs = async (
    strSDate?: string,
    strEDate?: string,
    strRepairman?: string,
    strReason?: string,
  ) => {
    this.otherService.Showspinner();
    const session = encodeURIComponent(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    );

    const resp = await axios.post(
      `GetRepairMaintenanceRecordNew?strUnitID=${this.Id}&strSDate=${
        strSDate == undefined ? '' : strSDate
      }&strEDate=${strEDate == undefined ? '' : strEDate}&strRepairman=${
        strRepairman == undefined ? '' : strRepairman
      }&strReason=${
        strReason == undefined ? '' : strReason
      }&strSession=${session}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}`,
    );
    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    if (resp.data.length == 0) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      this.reportData = resp.data;
    } else {
      this.reportData = resp.data;
      this.reportData.forEach((element: any, index: number) => {
        this.Total = element.iTotalCost + this.Total;
      });
    }
  };

  setlocation(
    fullName: any,
    fLat: any,
    fLon: any,
    strDate: any,
    strAddress: any,
    strSTime: any,
    strETime: any,
    strParkTime: any,
  ) {
    var model = {
      strDate: strDate,
      strAddress: strAddress,
      strSTime: strSTime,
      strETime: strETime,
      strParkTime: strParkTime,
    };
    if (this.Id == 'presenceCheck')
      localStorage.setItem('nameOfDriv', this.gurdService.encrypt(fullName));
    localStorage.setItem('ddval', this.summeryForRiderSalary.area);

    window.localStorage.setItem(
      'StopModel',
      this.gurdService.encrypt(JSON.stringify(model)),
    );
    window.localStorage.setItem('fLat', this.gurdService.encrypt(fLat));
    window.localStorage.setItem('fLon', this.gurdService.encrypt(fLon));
    this.router.navigate(['stopMap']);
  }

  setJournal(fLat: any, fLon: any, comment: any, time: any, date: any) {
    window.localStorage.setItem('fLat', this.gurdService.encrypt(fLat));
    window.localStorage.setItem('fLon', this.gurdService.encrypt(fLon));
    window.localStorage.setItem(
      'commentJournal',
      this.gurdService.encrypt(comment),
    );
    window.localStorage.setItem('timeJournal', this.gurdService.encrypt(time));
    window.localStorage.setItem('dateJournal', this.gurdService.encrypt(date));

    this.router.navigate(['stopMap/1']);
  }

  setRefueling(
    fLat: any,
    fLon: any,
    comment: any,
    time: any,
    date: any,
    fule: any,
    IDefKM: any,
  ) {
    window.localStorage.setItem('fLat', this.gurdService.encrypt(fLat));
    window.localStorage.setItem('fLon', this.gurdService.encrypt(fLon));
    window.localStorage.setItem(
      'commentJournal',
      this.gurdService.encrypt(comment),
    );
    window.localStorage.setItem('timeJournal', this.gurdService.encrypt(time));
    window.localStorage.setItem('dateJournal', this.gurdService.encrypt(date));
    window.localStorage.setItem('fule', this.gurdService.encrypt(fule));
    window.localStorage.setItem('IDefKM', this.gurdService.encrypt(IDefKM));

    this.router.navigate(['stopMap/2']);
  }

  getAllIncom = async (
    strSDate?: string,
    strEDate?: string,
    strComment?: string,
  ) => {
    var model = {
      strUnitID: this.Id,
      strSDate: `${strSDate == undefined ? '' : strSDate}`,
      strEDate: `${strEDate == undefined ? '' : strEDate}`,
      strComment: `${strComment == undefined ? '' : strComment}`,
      iSystemUser: this.gurdService.encrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.encrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    const resp = await axios.post(`GetCarRvenuessNew`, model);

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    if (resp.data.length == 0) {
      this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
      this.reportData = resp.data;
    } else {
      this.reportData = resp.data;
      this.reportData.forEach((element: any, index: number) => {
        this.TotalL = element.iAmount + this.TotalL;
      });
    }
  };

  guid() {
    this.otherService.guid(this.guidId);
  }

  getAreaData = async () => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      strSTime: this.stime,
      strETime: this.etime,
      iGeoFence: this.polyganId,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`Report_CarNavigationFunction`, model);
    this.otherService.nonespinner();
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
    }
    this.areaData = JSON.parse(resp.data);
    if (this.areaData.iResult == 0) {
      this.notifyService.showError(this.areaData.strError);
      return;
    }
    if (this.areaData?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siMoveTime + this.sTotalTime;
    });
    this.siMoveTime = Math.floor(this.sTotalTime / 60);
    this.siMoveTimem = Math.floor(this.sTotalTime - this.siMoveTime * 60);

    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siMoveTime + this.sTotalTime;
    });
    this.siMoveTime = Math.floor(this.sTotalTime / 60);
    this.siMoveTimem = Math.floor(this.sTotalTime - this.siMoveTime * 60);

    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siPresentTime + this.sTotalTime;
    });
    this.siPresentTime = Math.floor(this.sTotalTime / 60);
    this.siPresentTimem = Math.floor(this.sTotalTime - this.siPresentTime * 60);

    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siStopTime + this.sTotalTime;
    });

    this.siStopTime = Math.floor(this.sTotalTime / 60);
    this.siStopTimem = Math.floor(this.sTotalTime - this.siStopTime * 60);

    this.areaData.forEach((element: any) => {
      this.pimayesh = parseInt(this.pimayesh + element.fKmTotal);
    });
  };

  getEnterAndExit = async () => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataAz,
      strEDate: this.dataTa,
      strSTime: this.stime,
      strETime: this.etime,
      iGeoFence: this.polyganId,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`Report_InOutBaseEveryGeoFance`, model);
    this.otherService.nonespinner();

    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
    }
    this.areaData = JSON.parse(resp.data);
    if (this.areaData.iResult == 0) {
      this.notifyService.showError(this.areaData.strError);
      return;
    }
    if (this.areaData?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siMoveTime + this.sTotalTime;
    });
    this.siMoveTime = Math.floor(this.sTotalTime / 60);
    this.siMoveTimem = Math.floor(this.sTotalTime - this.siMoveTime * 60);

    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siMoveTime + this.sTotalTime;
    });
    this.siMoveTime = Math.floor(this.sTotalTime / 60);
    this.siMoveTimem = Math.floor(this.sTotalTime - this.siMoveTime * 60);

    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siPresentTime + this.sTotalTime;
    });
    this.siPresentTime = Math.floor(this.sTotalTime / 60);
    this.siPresentTimem = Math.floor(this.sTotalTime - this.siPresentTime * 60);

    this.sTotalTime = 0;
    this.areaData.forEach((el: any) => {
      this.sTotalTime = el.siStopTime + this.sTotalTime;
    });

    this.siStopTime = Math.floor(this.sTotalTime / 60);
    this.siStopTimem = Math.floor(this.sTotalTime - this.siStopTime * 60);

    this.areaData.forEach((element: any) => {
      this.pimayesh = parseInt(this.pimayesh + element.fKmTotal);
    });
  };

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    if (id == 'excel-table-saleryData') {
      let count = this.saleryData.length + 2;
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hTotalTime + ':' + this.mTotalTime)]],
        { origin: `G${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hStopTime + ':' + this.mStopTime)]],
        { origin: `H${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hmoveTime + ':' + this.mmoveTime)]],
        { origin: `I${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.summeryForRiderSalary.cityRide)]],
        { origin: `J${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.summeryForRiderSalary.OperationRide)]],
        { origin: `K${count}` },
      );
      XLSX.utils.sheet_add_aoa(ws, [[this.toPersian(this.dictance)]], {
        origin: `L${count}`,
      });
      XLSX.utils.sheet_add_aoa(ws, [[this.toPersian(this.tServiceCharge)]], {
        origin: `M${count}`,
      });
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hOvertime + ':' + this.mOvertime)]],
        { origin: `T${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.summeryForRiderSalary.encourageRide)]],
        { origin: `S${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.summeryForRiderSalary.EncouragOvertime)]],
        { origin: `R${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.getSeparatedValue(this.saleryTotal))]],
        { origin: `U${count}` },
      );
    }

    if (id == 'excel-table-active') {
      let count = this.reportData.length + 2;
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hTotalTime + ':' + this.mTotalTime)]],
        { origin: `F${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hStopTime + ':' + this.mStopTime)]],
        { origin: `G${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.hmoveTime + ':' + this.mmoveTime)]],
        { origin: `H${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(Number(this.dictance).toPrecision(10))]],
        { origin: `J${count}` },
      );
      XLSX.utils.sheet_add_aoa(
        ws,
        [[this.toPersian(this.getSeparatedValue(this.fuel))]],
        { origin: `I${count}` },
      );
    }

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  filter(val: any) {
    this.gpdioData = this.allGpdioData.filter((el: any) => {
      return el.strIOName.startsWith(val.value);
    });
  }

  filterDataTable(e: any) {
    this.reportData = this.filteredData;
    if (this.Id == 'presenceCheck' || this.Id == 'historyCheck')
      this.reportData = this.reportData.filter(
        (x: any) =>
          x.strFullName.includes(e) ||
          x.strMobileType_strComment.includes(e) ||
          x.strMobileDomain_strComment.includes(e),
      );

    if (this.Id == 18) {
      this.reportData = this.reportData.filter(
        (x: any) => x.strFullName.includes(e) || x.strTitle.includes(e),
      );
    }
  }

  exitAndEnterMap(id: any) {
    if (this.polyganId) {
      var url = `/stopMap/${id}!/${this.polyganId}`;
      this.router.navigate([url.trim()]);
    } else {
      var url = `/stopMap/${id}!`;
      this.router.navigate([url.trim()]);
    }
  }

  deleteSalery = async (api: any) => {
    var model: any = {
      strUnitID: this.Id,

      strSDate: this.dataStart.controls['date'].value,

      strEDate: this.dataEnd.controls['date'].value,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    if (this.type == '18') {
      model.strSDate = this.mdl_Date.controls['strSDate'].value;

      model.strEDate = this.mdl_Date.controls['strEDate'].value;
    }

    if (this.type == '17') {
      this.summeryForRiderSalary.source
        ? (model.iSourceGeoFence = this.summeryForRiderSalary.source)
        : '';

      this.summeryForRiderSalary.destination
        ? (model.iDestinationGeoFence = this.summeryForRiderSalary.destination)
        : '';
    }

    $.confirm({
      title:
        api == 'Radyab_Transportation_DailyReport_Delete'
          ? 'آیا از حذف اطمینان دارید؟'
          : `آیا از حذف تحلیل های قبلی اطمینان دارید؟ `,
      content:
        api == 'Radyab_Transportation_DailyReport_Delete'
          ? ''
          : 'در صورت تایید پس از اجرای درخواست دکمه جستجو را مجددا انتخاب کنید',
      type: 'red',
      buttons: {
        ok: {
          text: 'حذف',
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: async () => {
            this.otherService.Showspinner();
            const resp = await axios.post(`${api}`, model);
            this.otherService.nonespinner();
            let resParse = JSON.parse(resp.data);
            if (resParse.iResult == 0) {
              this.notifyService.showError(resParse.strError);
              return;
            }
            if (resParse?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');
              this.otherService.removeLocalStorage();
              this.router.navigate(['login']);
              return;
            } else {
              this.notifyService.showSuccess('تحلیل با موفقیت حذف شد');
              this.saleryData = [];
              this.tripInOutReport = [];
              this.reportData = [];
            }
            return;
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  remove_Transportaion_Cost = async (item: any) => {
    var model: any = {
      iGeoFence_RespectOriginDestination:
        item.iGeoFence_RespectOriginDestination,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    $.confirm({
      title: `آیا از حذف اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {
        ok: {
          text: 'حذف',

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {
            this.otherService.Showspinner();

            const resp = await axios.post(
              'Radyab_Transportation_DailyReport_DeleteOne',
              model,
            );

            this.otherService.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0)
              return this.notifyService.showError(resParse.strError);

            if (resParse?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            } else {
              this.notifyService.showSuccess('با موفقیت حذف شد');

              const index = this.tripInOutReport.indexOf(item);

              if (index != -1) this.tripInOutReport.splice(index, 1);
            }

            return;
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  searchSalery = async (api: any) => {
    var model = {
      strUnitID: this.Id,
      strSDate: this.dataStart.controls['date'].value,
      strEDate: this.dataEnd.controls['date'].value,
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),
    };

    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.saleryData = JSON.parse(resp.data);

    // console.log(this.saleryData)

    if (this.saleryData.iResult == 0) {
      this.notifyService.showError(this.saleryData.strError);
      return;
    }

    if (this.saleryData?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    this.dictance = 0;
    this.stopTime = 0;
    this.moveTime = 0;
    this.TotalTime = 0;
    this.saleryTotal = 0;
    this.totalTimeSpent = 0;
    this.overtime = 0;
    this.tServiceCharge = 0;
    this.hOvertime = 0;
    this.mOvertime = 0;
    this.summeryForRiderSalary.EncouragOvertime = 0;
    this.summeryForRiderSalary.serviceHours = 0;
    this.summeryForRiderSalary.cityRide = 0;
    this.summeryForRiderSalary.OperationRide = 0;
    this.summeryForRiderSalary.encourageRide = 0;
    this.saleryData.forEach((element: any, index: number) => {
      this.saleryTotal += element.iSalary;
      this.totalTimeSpent += element.iTotalTime;
      this.dictance += element.fKmTotal + element.iIncentiveKm;
      this.stopTime += element.siStopTime;
      this.summeryForRiderSalary.cityRide += element.fKmInTown;
      this.summeryForRiderSalary.OperationRide += element.fKmMission;
      this.summeryForRiderSalary.EncouragOvertime += element.iEncouragOvertime;
      this.summeryForRiderSalary.encourageRide += element.iIncentiveKm;
      this.moveTime += element.siMoveTime;
      this.TotalTime += element.siPresentTime;
      this.overtime =
        element.iIncentiveOvertime + this.overtime + element.iOvertime;
      this.summeryForRiderSalary.serviceHours += element.siServiceCharge;
      this.tServiceCharge = Math.floor(
        element.siServiceCharge + this.tServiceCharge,
      );
    });
    this.dictance = Math.round((this.dictance + Number.EPSILON) * 100) / 100;
    this.totalTimeSpent =
      Math.floor(this.totalTimeSpent / 60) + ':' + (this.totalTimeSpent % 60);

    this.hStopTime = Math.floor(this.stopTime / 60);
    this.mStopTime = Math.floor(this.stopTime - this.hStopTime * 60);

    this.hmoveTime = Math.floor(this.moveTime / 60);
    this.mmoveTime = Math.floor(this.moveTime - this.hmoveTime * 60);

    this.hTotalTime = Math.floor(this.TotalTime / 60);
    this.mTotalTime = Math.floor(this.TotalTime - this.hTotalTime * 60);

    this.hOvertime = Math.floor(this.overtime / 60);
    this.mOvertime = Math.floor(this.overtime - this.hOvertime * 60);
  };

  editSalery = async (id: any, index: any) => {
    this.saleryEditForm.reset({
      strStartTime: this.saleryData[index].strStartTime,
      strEndTime: this.saleryData[index].strEndTime,
      iAttendanceDriver: id,
      iEncouragOvertime: this.saleryData[index].iEncouragOvertime,
      iIncentiveKm: this.saleryData[index].iIncentiveKm,
      siServiceCharge: this.saleryData[index].siServiceCharge,
    });
  };

  editSaleryModal = async () => {
    var strStartTime = document.getElementById('Stime') as any;
    var strEndTime = document.getElementById('Etime') as any;
    var model = this.saleryEditForm.value;
    model.iSystemUser = this.gurdService.decrypt(
      window.localStorage.getItem('ID')!,
    );
    model.strSession = this.gurdService.decrypt(
      window.localStorage.getItem('Session')!,
    );
    model.strUnitID = this.Id;
    model.strStartTime = strStartTime.value;
    model.strEndTime = strEndTime.value;
    this.otherService.Showspinner();
    var apiurl =
      this.type == 16 ? 'Mobile_EditSalariBaseZone' : 'Mobile_EditSalari';
    const resp = await axios.post(apiurl, model);
    this.otherService.nonespinner();
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;
    }
    if (resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    $('#SaleryModal').modal('hide');
    this.notifyService.showSuccess('با موفقیت ثبت شد');
  };

  editAllSaleryModal = async () => {
    var strStartTime = document.getElementById('StimeAll') as any;
    var strEndTime = document.getElementById('EtimeAll') as any;
    var model = this.saleryEditAllForm.value;
    model.strUnitID = this.Id;
    model.strEDate = this.dataEnd.controls['date'].value;
    model.strSDate = this.dataStart.controls['date'].value;
    if ($('#editTimeS').prop('checked')) {
      model.strStartTime = strStartTime.value;
    } else {
      model.strStartTime = '';
    }
    if ($('#editTimeE').prop('checked')) {
      model.strEndTime = strEndTime.value;
    } else {
      model.strEndTime = '';
    }
    this.otherService.Showspinner();
    var apiurl =
      this.type == 16 ? 'Mobile_EditSalarisBaseZone' : 'Mobile_EditSalaris';
    const resp = await axios.post(apiurl, model);
    this.otherService.nonespinner();
    resp.data = JSON.parse(resp.data);
    if (resp.data.iResult == 0) {
      this.notifyService.showError(resp.data.strError);
      return;
    }
    if (resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }
    $('#edit-all-salery-modal').modal('hide');
    this.notifyService.showSuccess('با موفقیت ثبت شد');
  };

  newOpenMap() {
    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({
      source: this.source,
    });

    if (this.bOfflineMap) {
      this.layers.push(
        new TileLayer({
          source: new XYZ({
            url: this.strMapUrl,
            attributions: 'Map data © RayanAndishehNasr', //
          }),
        }),
      );
    } else {
      const styles = ['AerialWithLabelsOnDemand'];

      let i, ii;
      for (i = 0, ii = styles.length; i < ii; ++i) {
        this.layers.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new BingMaps({
              // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
              imagerySet: styles[i],
            }),
          }),
        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector);
    }
    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'test',
      layers: this.layers,
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 12,
      }),
    });

    //context menu
  }

  fileChange = async (event: any) => {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('uploadFile', file, file.name);
      this.otherService.Showspinner();
      const resp = await axios.post(
        `MobileReadExcelFile?strUnitID=${this.Id}`,
        formData,
      );
      if (resp.data.iResult == 0) {
        this.notifyService.showError(resp.data.strError);
        return;
      }
      if (resp.data?.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      } else {
        this.notifyService.showSuccess('با موفقیت ثبت شد');
      }
      this.otherService.nonespinner();

      //     let headers = new Headers();
      //     /** In Angular 5, including the header Content-Type can invalidate your request */
      //     headers.append('Content-Type', 'multipart/form-data');
      //     headers.append('Accept', 'application/json');
      //     let options = new RequestOptions({ headers: headers });
      //     this.http.post(`${this.apiEndPoint}`, formData, options)
      //         .map(res => res.json())
      //         .catch(error => Observable.throw(error))
      //         .subscribe(
      //             data => console.log('success'),
      //             error => console.log(error)
      //         )
    }
  };

  showFactor(item: any) {
    $.confirm({
      title: 'فاکتور',

      content: `<img src="data:image/jpeg;base64,${item.strImage}" alt="Your Image">`,

      type: 'blue',

      buttons: {
        cancel: {
          text: 'بستن',
        },
      },
    });
  }

  Route_FunctionReport = async () => {
    this.otherService.Showspinner();

    const resp = await axios.post(
      this.type == 21 || this.type == '21-1'
        ? `Route_FunctionReport`
        : this.type == 22
          ? `Route_FunctionReport_Totally`
          : this.type == 23
            ? 'Route_FunctionReport_PerformanceBasedRoute'
            : '',
      this.RouteReport_Model.value,
    );

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'FN' } });

      return;
    }

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.totalPrice = 0;

    this.totalLength = 0;

    this.totalTime = 0;

    this.totalCount = 0;

    this.list_RouteReport = res;

    this.list_RouteReport_Search = res;

    if (this.type == 21) {
      this.list_RouteReport.forEach((el: any) => {
        this.totalPrice += el.iCost;

        this.totalLength += el.fLength;

        this.totalTime += el.iTime;
      });

      this.totalTime = this.format_Time(this.totalTime);
    }

    if (this.type == 22 || this.type == 23) {
      this.list_RouteReport.forEach((el: any) => {
        this.totalPrice += el.iCost * el.iCount;

        this.totalCount += el.iCount;

        this.totalLength += el.fLength;

        this.totalTime += el.iTime;

        this.totalTime = this.totalTime / 3600;

        this.totalTime = +this.totalTime.toFixed(1);
      });
    }
  };

  route_Report_DeleteAll = async () => {
    let model = this.otherService.stringNumberToNumber(
      this.RouteReport_Model.value,
    );

    if (model.strEDate == '' || model.strSDate == '') {
      return this.notifyService.showError('لطفا مسیر و  تاریخ ها را وارد کنید');
    }

    $.confirm({
      title: `آیا از حذف تحلیل اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {
        ok: {
          text: 'حذف',

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {
            this.otherService.Showspinner();

            const resp = await axios.post(
              `Route_FunctionReport_DeleteAll`,
              this.RouteReport_Model.value,
            );

            if (resp.data && resp.data?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login'], {
                queryParams: { report: 'WAxas' },
              });

              return;
            }

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError) return this.notifyService.showError(res.strError);

            this.notifyService.showSuccess('عملیات با موفقیت انجام شد');

            this.Route_FunctionReport();
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  route_Analysis = async () => {
    let model = this.otherService.stringNumberToNumber(
      this.RouteReport_Model.value,
    );

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_FunctionReport_Analysis`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'analysis' } });

      return;
    }

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.notifyService.showSuccess('تحلیل با موفقیت انجام شد');

    this.Route_FunctionReport();
  };

  route_SummaryByDay = async () => {
    this.lst_Route_SummaryByDay = [];

    this.lstHeaders = [];

    this.lstRowValues = [];

    let model = this.otherService.stringNumberToNumber(
      this.RouteReport_Model.value,
    );

    if (model.strEDate == '' || model.strSDate == '') {
      return this.notifyService.showError('بازه زمانی را مشخص کنید!');
    }

    this.otherService.Showspinner();

    const resp = await axios.post(
      `Route_FunctionReport_RouteServiceSummaryByDay`,
      model,
    );

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'summary_ByDay' },
      });

      return;
    }

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    if (!res.length) return this.notifyService.showError('نتیجه ایی یافت نشد!');

    this.lst_Route_SummaryByDay = res;

    const headers = this.getHeaders(res[0]);

    this.lstHeaders = headers;

    res.forEach((el: any) => {
      this.lstRowValues.push(this.getValues(el, headers));
    });

    $('#SummaryByDay_Modal').modal('show');
  };

  getHeaders(obj: any): string[] {
    const keys = Object.keys(obj);

    const numberKeys = keys.filter((k) => !isNaN(Number(k)));

    this.iDays = numberKeys.length;

    const stringKeys = keys.filter((k) => isNaN(Number(k)) && k !== 'جمع کل');

    const sumKey = keys.find((k) => k === 'جمع کل');

    const result: string[] = [];

    result.push(...stringKeys);

    result.push(...numberKeys);

    if (sumKey) result.push(sumKey);

    return result;
  }

  getValues(obj: any, headers: string[]): any[] {
    return headers.map((key) => obj[key]);
  }

  getKeys(obj: any): string[] {
    if (!obj) return;

    return Object.keys(obj);
  }

  route_SalarySummary = async () => {
    this.iAmount = 0;

    this.iCount = 0;

    let model = this.otherService.stringNumberToNumber(
      this.RouteReport_Model.value,
    );

    if (model.strEDate == '' || model.strSDate == '') {
      return this.notifyService.showError('بازه زمانی را مشخص کنید!');
    }

    this.otherService.Showspinner();

    const resp = await axios.post(
      `Route_FunctionReport_DriverSalarySummary`,
      model,
    );

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'route_SalarySummary' },
      });

      return;
    }

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    if (!res.length) return this.notifyService.showError('نتیجه ایی یافت نشد!');

    this.lst_SalarySummary = res;

    this.lst_SalarySummary.forEach((el: any) => {
      this.iAmount += el.iAmount;

      this.iCount += el.iCount;
    });

    this.lst_SalarySummary_Search = res;

    $('#SalarySummary_Modal').modal('show');
  };

  filter_list_BySalary(val: any) {
    this.lst_SalarySummary = this.lst_SalarySummary_Search.filter((el: any) => {
      return el.strFullName.includes(val.value);
    });

    if (val?.trim() == '') {
      this.lst_SalarySummary = this.lst_SalarySummary_Search;
    }
  }

  filter_list_RouteReport(val: any) {
    this.list_RouteReport = this.list_RouteReport_Search.filter((el: any) => {
      return (
        el.strFullName.includes(val.value) ||
        el.strDayName.includes(val.value) ||
        el.strRoute_strName.includes(val.value) ||
        el.strSourceStationName.includes(val.value) ||
        el.strDestinationStationName.includes(val.value) ||
        el.strMobileType_strComment.includes(val.value) ||
        el.strVehicleNo.includes(val.value)
      );
    });

    if (val?.trim() == '') {
      this.list_RouteReport = this.list_RouteReport_Search;
    }
  }

  removeRoute(item: any) {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iRoute_FunctionReport: item.iRoute_FunctionReport,
    };

    $.confirm({
      title: `آیا از حذف اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {
        ok: {
          text: 'حذف',

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {
            this.otherService.Showspinner();

            const resp = await axios.post('Route_FunctionReport_Delete', model);

            this.otherService.nonespinner();

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0)
              return this.notifyService.showError(resParse.strError);

            if (resParse?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            } else {
              this.notifyService.showSuccess('با موفقیت حذف شد');

              const index = this.list_RouteReport.indexOf(item);

              if (index != -1) this.list_RouteReport.splice(index, 1);
            }

            return;
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  intermediate_Station = async (item: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iRoute_FunctionReport: item.iRoute_FunctionReport,
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_StationsFunctionReport_List`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], {
        queryParams: { report: 'intermediate-station' },
      });

      return;
    }

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    this.list_Intermediate_Station = res;

    $('#intermediate-Station').modal('show');
  };

  showStation_Map(item: any) {
    var model = {
      strDate: '',

      strAddress: '',

      strSTime: '',

      strETime: '',

      strParkTime: '',
    };

    localStorage.setItem('ddval', this.summeryForRiderSalary.area);

    window.localStorage.setItem(
      'StopModel',
      this.gurdService.encrypt(JSON.stringify(model)),
    );

    window.localStorage.setItem('fLat', this.gurdService.encrypt(item.fLat));

    window.localStorage.setItem('fLon', this.gurdService.encrypt(item.fLon));

    window.open('/stopMap', '_blank');
  }

  recalculate_Distance = async () => {
    $.confirm({
      title: ` با توجه به زمانبر بودن این فرایند آیا از محاسبه مجدد اطمینان دارید؟`,

      content: 'توصیه : بازه تاریخ را طولانی در نظر نگیرید',

      type: 'blue',

      buttons: {
        ok: {
          text: 'محاسبه',

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {
            var model = {
              iSystemUser: this.gurdService.decrypt(
                window.localStorage.getItem('ID')!,
              ),

              strSession: this.gurdService.decrypt(
                window.localStorage.getItem('Session')!,
              ),

              strUnitID: this.Id,

              strSDate: this.dataAz,

              strEDate: this.dataTa,
            };

            this.otherService.Showspinner();

            const resp = await axios.post(
              `ReportFunctionAndDistanceMountly_ReCal`,
              this.otherService.stringNumberToNumber(model),
            );

            this.otherService.nonespinner();

            if (resp.data && resp.data?.ISSessionExpired == true) {
              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login'], {
                queryParams: { report: 'RxcsK' },
              });

              return;
            }

            if (!resp.data.length)
              return this.notifyService.showError('نتیجه ایی یافت نشد');

            let res = JSON.parse(resp.data);

            if (res.bError) return this.notifyService.showError(res.strError);

            this.reportData = resp.data;

            this.report_Obj = {
              iFunction: 0, // زمان کل

              iParkTime: 0, // کل زمان توقف

              iAbsoulatFunction: 0, // کل زمان حرکت

              Distance: 0, // کل میزان پیمایش

              fGasPer100: 0, // کل مصرف سوخت
            };

            this.reportData.forEach((element: any, index: number) => {
              this.report_Obj = {
                iFunction: this.report_Obj.iFunction + element.iFunction,

                iParkTime: this.report_Obj.iParkTime + element.iParkTime,

                iAbsoulatFunction:
                  this.report_Obj.iAbsoulatFunction + element.iAbsoulatFunction,

                Distance: this.report_Obj.Distance + element.Distance,

                fGasPer100: this.report_Obj.fGasPer100 + element.fGasPer100,
              };

              // this.fuel = element.fGasPer100 + this.fuel;

              // this.dictance = element.Distance + this.dictance;

              // this.stopTime = element.iParkTime + this.stopTime;

              // this.moveTime = element.iAbsoulatFunction + this.moveTime;

              // this.TotalTime = element.iFunction + this.TotalTime;
            });

            // this.hStopTime = Math.floor(this.stopTime / 3600);

            // this.mStopTime = Math.floor((this.stopTime - this.hStopTime * 3600) / 60);

            // this.sStopTime = this.stopTime - (this.hStopTime * 3600 + this.mStopTime * 60);

            // this.hmoveTime = Math.floor(this.moveTime / 3600);

            // this.mmoveTime = Math.floor((this.moveTime - this.hmoveTime * 3600) / 60);

            // this.smoveTime = this.moveTime - (this.hmoveTime * 3600 + this.mmoveTime * 60);

            // this.hTotalTime = Math.floor(this.TotalTime / 3600);

            // this.mTotalTime = Math.floor((this.TotalTime - this.hTotalTime * 3600) / 60);

            // this.sTotalTime = this.TotalTime - (this.hTotalTime * 3600 + this.mTotalTime * 60);
          },
        },

        cancel: {
          text: 'لغو',
        },
      },
    });
  };

  show_FunctionReport = async (item: any) => {
    var model = this.otherService.stringNumberToNumber({
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(
        window.localStorage.getItem('Session')!,
      ),

      iRoute_FunctionReport: item.iRoute_FunctionReport,
    });

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_FunctionReport_Passenger_List`, model);

    this.otherService.nonespinner();

    if (resp.data && resp.data?.ISSessionExpired == true) {
      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { report: 'W22xs2RK' } });

      return;
    }

    let res = JSON.parse(resp.data);

    if (res.bError) return this.notifyService.showError(res.strError);

    if (!res.length || res == '[]')
      return this.notifyService.showError('اطلاعاتی یافت نشد');

    this.list_ReportPassenger = res;

    this.list_ReportPassenger_Search = res;

    $('#Func_Passenger_Modal').modal('show');
  };

  filter_list_Passenger(val: any) {
    this.list_ReportPassenger = this.list_ReportPassenger_Search.filter(
      (el: any) => {
        return (
          el.strPassenger_FullName?.includes(val.value) ||
          el.strName?.includes(val.value) ||
          el.strPersonnelID?.includes(val.value)
        );
      },
    );

    if (val.value?.trim() == '') {
      this.list_ReportPassenger = this.list_ReportPassenger_Search;
    }
  }
}
